export default "__VITE_ASSET__ef9ad9fd__"